import $ from 'cash-dom';

let instance = null;

/**
 * Class Spinner shows and hides loading spinner.
 * Targets `#loader-holder` (partner flow), else `#main-spinner` or `.main-spinner`
 * (see `controllers/partials/widgets/spinner.php` + `scss/common/_spinner.scss`).
 * Example of usage:
 * ```
	 // import spinner
	 import spinner from './components/spinner';

	 // in code
	 spinner.show();  // pass number, it's interval time, 500 is default

	 setTimeout(() => {
		 spinner.hide();
	 }, 2000);
 * ```
 */
class Spinner {
	constructor() {
		if (!instance) {
			this._pw_spinner = $('#loader-holder');
			this._is_pw = this._pw_spinner.length;

			if (this._is_pw) {
				this._$spinner = this._pw_spinner;
			} else {
				this._$spinner =
					$('#main-spinner').length > 0 ? $('#main-spinner') : $('.main-spinner').first();
				this._$variant_1 = this._$spinner.find('.variant-1');
				this._$variant_2 = this._$spinner.find('.variant-2');
				this._hasLegacyVariants =
					this._$variant_1.length > 0 && this._$variant_2.length > 0;

				this._intervalId = null;

				this._is_shown_variant_1 = true;
				this._is_showing = false;

			}

			instance = this;
		}

		return instance;
	}

	show(intervalTime = 500) {
		if (this._is_showing) {
			return;
		}

		if (this._is_pw) {
			this._$spinner.css('display', 'flex');
		} else {
			if (this._hasLegacyVariants) {
				this._intervalId = setInterval(() => {
					this._toggleVariant();
				}, intervalTime);
			}

			this._$spinner.show();
		}

		this._is_showing = true;
	}

	hide() {
		if (!this._is_showing) {
			return;
		}

		this._$spinner.hide();

		if (!this._is_pw) {
			clearInterval(this._intervalId);
			this._intervalId = null;
		}

		this._is_showing = false;
	}

	_toggleVariant() {
		if (!this._hasLegacyVariants) {
			return;
		}

		if (this._is_shown_variant_1) {
			this._$variant_1.hide();
			this._$variant_2.show();
			this._is_shown_variant_1 = false;
		} else {
			this._$variant_1.show();
			this._$variant_2.hide();
			this._is_shown_variant_1 = true;
		}
	}
}

export default new Spinner();
